import list from './list'
import edit from './edit'
import create from './create'
import icon from '@material-ui/icons/Person'

const channels = { list, edit, create, icon, options: { label: 'Channels' } }

export default channels
